import React from 'react'
import PropTypes from 'prop-types'
import { FormControl } from 'react-bootstrap'

import PopupTypes from '../../../popup_types'
import {
  GlgPopup,
  GlgPopupForm,
  GlgFormInput,
} from 'SharedComponents'

const ChangeNamePopupSimGolf = ({ show, data, onClose, onSave }) => {
  const handleClose = () => {
    onClose(PopupTypes.CHANGE_NAME)
  }

  const handleSave = (formData) => {
    if (data && formData.new_name && formData.new_name.trim()) {
      onSave(data.leagueId, formData.new_name.trim())
    }
  }

  const leagueName = data && data.leagueName ? data.leagueName : ''

  return (
    <GlgPopup
      modalClass='create_clone_event_league general_sim_golf_popup'
      title={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.change_name') }
      show={ show }
      onClose={ handleClose }
      onSave={ handleSave }
      saveButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.save') }
      closeButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.cancel') }
      >
      <span className='form_content_popup_sim_golf'>
        <GlgPopupForm>
          <GlgFormInput
            label={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_labels.event_name') }
          >
            <FormControl
              name='new_name'
              type='text'
              defaultValue={ leagueName }
              autoFocus={ true }
            />
          </GlgFormInput>
        </GlgPopupForm>
      </span>
    </GlgPopup>
  )
}

ChangeNamePopupSimGolf.propTypes = {
  data: PropTypes.object,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default ChangeNamePopupSimGolf
